<template>
    <div>
        <el-dialog ref="relateFormDialog" :modal-append-to-body="false"  :before-close="handleDialogClose" :close-on-click-modal="false" :title="relateTitle" :visible.sync="relateFormDialog"  class="custom-form-dialog" :width="relateType == 'relate_approval' ? '800px' : '520px'">
            <el-form ref="formData" :model="formData" :rules="formRules" label-position="top">
                <el-form-item label="选择关联商机" prop="business_id" v-if="relateType == 'relate_business'">
                    <div>
                        <el-select  @focus="handleClickChangeBusiness"  popper-class="selectPopperHideClass" class="select_cursor_pointer" filterable placeholder="请选择关联商机" @remove-tag="handleClickRemoveItem($event,'business')" remote v-model="formData.business_id" multiple >
                            <el-option v-for="(item, index) in formData.relate"   :key="item.project_id" :label="item.project_name" :value="item.project_id"></el-option>
                        </el-select>
                    </div>

                    <div class="mt_4">
                        <el-checkbox-group v-model="formData.sync" >
                            <el-checkbox label="order" key="order">同步关联订单</el-checkbox>
                            <br>
                            <el-checkbox label="workorder" key="workorder">同步关联工单</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>

                <el-form-item label="选择关联订单" prop="order_id" v-if="relateType == 'relate_order'">
                    <div>
                        <el-select  @focus="handleClickChangeOrder"  popper-class="selectPopperHideClass" class="select_cursor_pointer" filterable placeholder="请选择关联订单" @remove-tag="handleClickRemoveItem($event,'order')" remote v-model="formData.order_id" multiple >
                            <el-option v-for="(item, index) in formData.relate"   :key="item.order_id" :label="item.order_num" :value="item.order_id"></el-option>
                        </el-select>
                    </div>
                    <div class="mt_4">
                        <el-checkbox-group v-model="formData.sync" >
                            <el-checkbox label="project" key="project">同步关联商机</el-checkbox>
                            <br>
                            <el-checkbox label="workorder" key="workorder">同步关联工单</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>

                <el-form-item label="选择关联工单" prop="work_order_id" v-if="relateType == 'relate_work_order'">
                    <el-select   @focus="handleClickChangeWorkOrder"  popper-class="selectPopperHideClass" class="select_cursor_pointer" filterable placeholder="请选择关联工单" @remove-tag="handleClickRemoveItem($event,'workorder')" remote v-model="formData.work_order_id" multiple >
                        <el-option v-for="(item, index) in formData.relate"   :key="item.workorder_id" :label="item.workorder_num" :value="item.workorder_id"></el-option>
                    </el-select>
                    <div class="mt_4">
                        <el-checkbox-group v-model="formData.sync" >
                            <el-checkbox label="project" key="project">同步关联商机</el-checkbox>
                            <br>
                            <el-checkbox label="order" key="order">同步关联订单</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>

                <!--发起审批-->
                <template v-if="relateType == 'add_approval'">
                    <div class="add_approval_wrap">
                        <ul>
                            <li v-for="item in approvalSetTypeList" @click="handleClickAddApproval(item)" :class="activeApproval.approval_set_id == item.approval_set_id ? 'active' : ''">
                                <div class="icon">
                                    <img :src="item.icon" alt="">
                                </div>
                                <p v-text="item.name"></p>
                            </li>
                        </ul>
                    </div>

                </template>
                <!--关联审批-->
                <template  v-if="relateType == 'relate_approval'">
                    <div class="relate_approval_wrap" v-loading="loading">
                        <div class="relate_approval_search">
                            <el-select  v-model="approvalSearchForm.approval_type_ids"   clearable collapse-tags filterable  multiple  placeholder="请选择审批类型"  size="small"  @change="handleClickSearch">
                                <el-option  v-for="type in approvalSetTypeList" :key="type.id" :label="type.name" :value="type.approval_set_id" ></el-option>
                            </el-select>
                            <el-input size="small" v-model="approvalSearchForm.approval_keyword" placeholder="请输入搜索内容"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                            </el-input>
                        </div>
                        <div class="relate_approval_tab">
                            <span @click="handleClickApprovalTab(item.value)" v-for="item in approvalTabList" v-text="item.name" :class="item.value == approvalSearchForm.action ? 'active' : ''"></span>
                        </div>
                        <div class="relate_approval_list">
                            <ul>
                                <li v-for="item in approvalList" :class="formData.relate.find(find => find.relate_id == item.approval_id) ? 'active' : ''" @click="handleClickChangeApproval(item)">
                                    <div class="top">
                                        <div class="title flex_js_wrap">
                                            <div>
                                                <h5 v-text="item.approval_set_name"></h5>
                                                <span class="id_num">ID:{{item.approval_id}}</span>
                                            </div>
                                            <div>
                                                <span class="approval_status approval_status_1">已通过</span>
                                            </div>
                                        </div>
                                        <div class="approve_user_time">
                                            <div  class="user_info ellipsis">
                                                <img :src="item.user.avatar ? item.user.avatar : defaultImg" alt="">
                                                <span class="ellipsis">{{item.user.name}}</span>
                                            </div>
                                            <div  class="time_info ellipsis">申请时间：{{item.created_at}}</div>
                                        </div>
                                    </div>
                                    <div class="bottom">
                                        <el-link class="approval_link" :underline="false" type="primary" @click.stop="handleClickApprovalDetail">
                                            查看详情 <i class="iconfont icon-youjiantou1"></i>
                                        </el-link>
                                        <div class="overview_list" v-if="item.overview_fields && item.overview_fields.length > 0">
                                            <OverviewFields :overviewFields="item.overview_fields"   />
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <el-divider v-if="approvalList.length == 0">暂无数据</el-divider>
                        </div>
                        <div class="relate_approval_page">
                            <el-pagination background
                                           size="mini"
                                           @size-change="handleSizeChange"
                                           @current-change="handleCurrentChange"
                                           :current-page="pagination.pageNum"
                                           :page-sizes="pagination.pageSizes"
                                           :page-size="pagination.pageSize"
                                           :layout="pagination.layout"
                                           :pager-count="5"
                                           :total="pagination.total">
                            </el-pagination>
                        </div>
                    </div>
                </template>

            </el-form>
            <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button :disabled="BtnDisabled" type="primary" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>

        </el-dialog>
        <ChangeBusiness  v-if="changeBusinessDialog" :changeBusinessDialog.sync="changeBusinessDialog" :disabledData="projectDetail.business_list" :selectBusinessData="formData.relate" @success="changeBusinessSuccess"/>
        <ChangeOrder  v-if="changeOrderDialog" :changeOrderDialog.sync="changeOrderDialog" :disabledData="projectDetail.order_list" :selectOrderData="formData.relate" @success="changeOrderSuccess"/>
        <ChangeWorkOrder  v-if="changeWorkOrderDialog"  :changeWorkOrderDialog.sync="changeWorkOrderDialog" :disabledData="projectDetail.work_order_list" :selectWorkOrderData="formData.relate" @success="changeWorkOrderSuccess"/>

    </div>

</template>
<script>
import {AllApprovalSetList,getProjectList,ProjectManageRelate,getApprovalType,getRelateApproval } from "@/api/index.js"
import {pagination} from '@/mixins'
import ChangeBusiness from  "./change_business"
import ChangeOrder from  "./change_order"
import ChangeWorkOrder from  "./change_work_order"
import OverviewFields from "@/components/pComponents/overviewFields.vue";
export default {
    name: "relate_form",
    components: {
        ChangeBusiness,
        ChangeOrder,
        ChangeWorkOrder,
        OverviewFields
    },
    props: {
        relateFormDialog: {
            type: Boolean,
            default: false
        },
        projectId: {
            type: Number,
            default: 0
        },
        projectDetail: {
            type: Object,
            default: ()=>{}
        },
        relateType: {
            type: String,
            default: 'relate_business'
        },
    },
    mixins: [pagination],
    data() {
        return {
            loading:false,
            defaultImg: require("@/assets/images/default.jpg"),
            BtnDisabled:false,
            formData: {
                business_id:[],
                order_id: [],
                work_order_id: [],
                sync:[],
                relate:[],
                approval_ids:[],

            },
            formRules: {
                business_id: [{required: true, message: "请选择关联的商机", trigger: 'change'}],
                order_id: [{required: true, message: "请选择关联的订单", trigger: 'change'}],
                work_order_id: [{required: true, message: "请选择关联的工单", trigger: 'change'}],
            },
            relateTitle:'',
            businessList:[],
            orderList:[],
            workOrderList:[],
            changeBusinessDialog:false,
            changeOrderDialog:false,
            changeWorkOrderDialog:false,

            approvalSearchForm:{
                approval_type_ids:[],
                approval_keyword:'',
                approval_status:1,
                action:'initiated_by_me'
            },
            approvalTabList:[
                {value:'initiated_by_me',name:'已发起'},
                {value:'already_handled_by_me',name:'已处理'},
                {value:'received_by_me',name:'已收到'},
            ],
            activeApproval:{},
            approvalSetTypeList:[],
            approvalList:[]
        }
    },
    created() {
        this.relateTitle = this.relateType == 'relate_business' ? '关联商机' : this.relateType == 'relate_order' ?  '关联订单' :
                           this.relateType == 'relate_work_order' ? '关联工单' : this.relateType == 'relate_approval' ? '关联审批' :
                           this.relateType == 'add_approval' ? '发起审批' : ''
        if(this.relateType == 'relate_business'){

        }else if(this.relateType == 'relate_order'){

        }else if(this.relateType == 'relate_work_order'){

        }else if(this.relateType == 'relate_approval'){
            this.getApprovalType()
            this.getApprovalList()

        }else if(this.relateType == 'add_approval'){
            this.getApprovalType()
        }
    },
    methods: {

        // 选择商机
        handleClickChangeBusiness(){
            console.log(this.formData.relate);
            this.changeBusinessDialog = true
        },
        // 选择商机回调
        changeBusinessSuccess(data){
            this.formData.business_id = []
            this.formData.relate = []
            data.forEach((item)=>{
                let json = {project_id:item.project_id,project_name:item.project_name}
                this.formData.business_id.push(item.project_id)
                this.formData.relate.push(json)
            })
        },
        // 选择订单
        handleClickChangeOrder(){
            this.changeOrderDialog = true
        },
        // 选择订单回调
        changeOrderSuccess(data){
            this.formData.order_id = []
            this.formData.relate = []
            data.forEach((item)=>{
                let json = {order_id:item.order_id,order_num:item.order_num,project_id:item.project_id}
                this.formData.order_id.push(item.order_id)
                this.formData.relate.push(json)
            })
        },

        // 选择工单
        handleClickChangeWorkOrder(){
            this.changeWorkOrderDialog = true
        },
        // 选择工单回调
        changeWorkOrderSuccess(data){
            this.formData.work_order_id = []
            this.formData.relate = []
            data.forEach((item)=>{
                let json = {workorder_id:item.workorder_id,workorder_num:item.workorder_num}
                this.formData.work_order_id.push(item.workorder_id)
                this.formData.relate.push(json)
            })
        },
        // 删除商机
        handleClickRemoveItem(value,type){
            if(type == 'business'){
                this.formData.relate.splice(this.formData.relate.findIndex(find => find.project_id == value),1)
            }else if(type == 'order'){
                this.formData.relate.splice(this.formData.relate.findIndex(find => find.order_id == value),1)
            }else if(type == 'workorder'){
                this.formData.relate.splice(this.formData.relate.findIndex(find => find.workorder_id == value),1)
            }
        },


        handleClickSearch(){
            this.pagination.pageNum = 1;
            this.getApprovalList()
        },
        handleClickApprovalTab(value){
            this.approvalSearchForm.action = value
            this.handleClickSearch()
        },
        // 页码改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.handleClickSearch();
        },
        // 页数改变
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page
            this.handleClickSearch();
        },

        // 审批详情
        handleClickApprovalDetail(item) {
            this.$showApprovalDetail({
                approval_id: item.approval_id,
            }).then((res) => {

            });
        },
        // 获取可选的审批类型
        getApprovalType(keyword){
            let postData = {
                approval_types:{
                    controls:[
                        'control_payable'
                    ],
                    type:[
                       'purchase'
                    ]
                }
            }
            getApprovalType(postData).then(res => {
                if (res.code === 200) {
                    const {data} = res
                    this.approvalSetTypeList = data
                }
            })
        },
        // 获取审批列表
        getApprovalList(){
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword:this.approvalSearchForm.approval_keyword,
                action: this.approvalSearchForm.action,
                approval_set_ids: this.approvalSearchForm.approval_type_ids,
                approval_status:1,
                approval_types:{
                    controls:[
                        'control_payable'
                    ],
                    type:[
                        'purchase'
                    ]
                }
            }
            this.loading = true
            getRelateApproval(postData).then(res => {
                if (res.code === 200) {
                    let {data, total} = res.data
                    this.approvalList = data
                    this.pagination.total = total
                }else{
                    this.BtnDisabled = false
                }
                this.loading = false
            })
        },
        //新增审批
        handleClickAddApproval(item){
            this.activeApproval = item
        },
        // 选中审批
        handleClickChangeApproval(item){
            console.log(item);
            if(this.formData.relate.findIndex(find => find.relate_id == item.approval_id) >-1){
                this.formData.relate.splice(this.formData.relate.findIndex(find => find.relate_id == item.approval_id),1)
            }else{
                let json = {relate_id:item.approval_id,relate_num:'',approval_set_name:item.approval_set_name}
                this.formData.relate.push(json)
            }
        },
        handleDialogClose() {
            this.$emit("update:relateFormDialog", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    if(this.relateType == 'relate_business'){ //关联商机
                        let postData = {
                            id: this.projectId,
                            relate_type:'project',
                            sync:this.formData.sync,
                            relate:this.formData.relate.map((item)=>{ return {relate_id:item.project_id,relate_num:'',project_name:item.project_name}}),
                        }
                        this.BtnDisabled = true;
                        ProjectManageRelate(postData).then(res => {
                            if (res.code === 200) {
                                this.$message.success(res.message)
                                this.$emit("update:relateFormDialog", false)
                                this.$emit('success')
                            } else {
                                this.BtnDisabled = false;
                            }
                        }).catch(() => {
                            this.BtnDisabled = false;
                        })
                    }
                    if(this.relateType == 'relate_order'){ //关联订单
                        let postData = {
                            id: this.projectId,
                            relate_type:'order',
                            sync:this.formData.sync,
                            relate:this.formData.relate.map((item)=>{ return {relate_id:item.order_id,relate_num:item.order_num}}),
                        }
                        this.BtnDisabled = true;
                        ProjectManageRelate(postData).then(res => {
                            if (res.code === 200) {
                                this.$message.success(res.message)
                                this.$emit("update:relateFormDialog", false)
                                this.$emit('success')
                            } else {
                                this.BtnDisabled = false;
                            }
                        }).catch(() => {
                            this.BtnDisabled = false;
                        })
                    }
                    if(this.relateType == 'relate_work_order'){ //关联工单
                        let postData = {
                            id: this.projectId,
                            relate_type:'workorder',
                            sync:this.formData.sync,
                            relate:this.formData.relate.map((item)=>{ return {relate_id:item.workorder_id,relate_num:item.workorder_num}}),
                        }
                        this.BtnDisabled = true;
                        ProjectManageRelate(postData).then(res => {
                            if (res.code === 200) {
                                this.$message.success(res.message)
                                this.$emit("update:relateFormDialog", false)
                                this.$emit('success')
                            } else {
                                this.BtnDisabled = false;
                            }
                        }).catch(() => {
                            this.BtnDisabled = false;
                        })
                    }
                    if(this.relateType == 'add_approval'){
                        if(!this.activeApproval || !this.activeApproval.approval_set_id){return this.$message.error('请选择审批类型')}
                        this.$router.push({
                            name: 'approveAdd',
                            query:{
                                id:this.activeApproval.approval_set_id,
                                name:this.activeApproval.name,
                                type: this.activeApproval.type
                            },
                            params: {
                                isPush: true
                            }
                        })
                    }
                    if(this.relateType == 'relate_approval'){ //关联审批
                        let postData = {
                            id: this.projectId,
                            relate_type:'approval',
                            sync:[],
                            relate:this.formData.relate,
                        }
                        this.BtnDisabled = true;
                        ProjectManageRelate(postData).then(res => {
                            if (res.code === 200) {
                                this.$message.success(res.message)
                                this.$emit("update:relateFormDialog", false)
                                this.$emit('success')
                            } else {
                                this.BtnDisabled = false;
                            }
                        }).catch(() => {
                            this.BtnDisabled = false;
                        })
                    }

                }
            })
        },



    }
}
</script>
<style lang="scss" scoped>
    .add_approval_wrap{
        width: 100%;
        height: 268px;
        overflow: auto;
        ul{
            display: flex;
            flex-wrap: wrap;
            gap: 24px;
            li{
                min-width: 141px;
                width: 141px;
                border-radius: 6px;
                background: rgb(255, 255, 255);
                border: 1px solid rgba(0, 0, 0, 0.04);
                padding: 0 12px;
                height: 60px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                cursor: pointer;
                &:hover{
                    background: rgba(0, 0, 0, 0.04);
                }
                &.active{
                    border: 1px solid rgba(41, 144, 255, 1);
                }
                .icon{
                    width: 32px;
                    img{
                        display: block;
                        width: 32px;
                        height: 32px;
                    }
                }
                p{
                    width: calc(100% - 32px);
                    padding-left: 8px;
                    box-sizing: border-box;
                    color: rgb(102, 102, 102);
                    font-size: 14px;
                    line-height: 22px;
                    height: 44px;
                    display: flex;
                    align-items: center;
                }
            }
        }

    }
    .relate_approval_wrap{
        width: 100%;
        .relate_approval_search{
            display: flex;
            .el-select{
                width: 272px;
                margin-right: 16px;
            }
            .el-input{
                width: 272px;
            }
        }
        .relate_approval_tab{
            margin-top: 16px;
            width: 100%;
            height: 40px;
            display: flex;
            border-bottom: 1px solid rgba(232, 232, 232, 1);
            box-sizing: border-box;
            span{
                display: block;
                padding: 0 16px;
                color: rgba(102, 102, 102, 1);
                line-height: 40px;
                cursor: pointer;
                &.active{
                    border-top: 1px solid rgba(25, 144, 255, 0.16);
                    border-bottom: 2px solid rgba(25, 144, 255, 1);
                    font-weight: bold;
                    color: rgba(41, 144, 255, 1);
                }
            }
        }
        .relate_approval_list{
            height:calc( 66vh - 100px);
            overflow: auto;
            ul{
                width: 100%;
                li{
                    width: 100%;
                    margin-top: 16px;
                    border-radius: 4px;
                    background: rgba(247, 248, 250, 1);
                    border: 1px solid rgba(247, 248, 250, 1);
                    cursor: pointer;
                    &.active{
                        border: 1px solid rgba(41, 144, 255, 1);
                        box-sizing: border-box;
                    }
                    .top{
                        padding: 12px;
                        border-bottom: 1px solid rgba(232, 232, 232, 1);
                        box-sizing: border-box;
                        .title{
                            width: 100%;
                            h5{
                                line-height: 22px;
                                color: rgba(51, 51, 51, 1);
                                margin-right: 12px;
                                display: inline-block;
                            }
                            span.id_num{
                                color: rgba(102, 102, 102, 1);
                                font-size: 12px;
                            }
                            span.approval_status {
                                width: 52px;
                                min-width: 52px;
                                height: 22px;
                                line-height: 22px;
                                box-sizing: border-box;
                                border-radius: 2px;
                                background: rgba(251, 173, 19, 0.1);
                                border: 1px solid rgba(251, 173, 19, 1);
                                font-size: 12px;
                                color: rgba(251, 173, 19, 1);
                                text-align: center;
                                display: inline-block;
                                &.approval_status_0 {
                                    color: #fbad13;
                                    border-color: #fbad13;
                                    background: rgba(251, 173, 19, 0.1);
                                }

                                &.approval_status_1 {
                                    color: #52c41b;
                                    border-color: #52c41b;
                                    background: rgba(82, 196, 27, 0.1);
                                }

                                &.approval_status_2 {
                                    color: #ff4d4f;
                                    border-color: #ff4d4f;
                                    background: rgba(255, 77, 79, 0.1);
                                }

                                &.approval_status_3 {
                                    color: #bfbfbf;
                                    border-color: #bfbfbf;
                                    background: rgba(191, 191, 191, 0.1);
                                }
                            }


                        }
                        .approve_user_time {
                            margin-top: 8px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            .user_info {
                                width: 100px;
                                line-height: 22px;
                                display: flex;
                                align-items: center;

                                img {
                                    width: 22px;
                                    height: 22px;
                                    border-radius: 50%;
                                }

                                span {
                                    max-width: calc(100% - 30px);
                                    color: rgba(51, 51, 51, 1);
                                    font-size: 14px;
                                    margin-left: 8px;
                                }
                            }

                            .time_info {
                                font-size: 12px;
                                color: rgba(102, 102, 102, 1);

                                span {
                                    color: rgba(153, 153, 153, 1);
                                }
                            }
                        }
                    }
                    .bottom{
                        width: 100%;
                        position: relative;
                        padding: 12px ;
                        box-sizing: border-box;
                        min-height: 44px;
                        .file_list{
                            line-height: 18px;
                            margin-bottom: 8px;
                            font-size: 12px;
                            color: rgba(51, 51, 51, 1);
                            &:last-child{
                                margin-bottom: 0;
                            }
                        }
                        .approval_link{
                            position: absolute;
                            bottom: 12px;
                            right: 12px;
                        }
                    }
                }
            }
        }
        .relate_approval_page{
            padding: 0px 0 0;
            box-sizing: border-box;
        }
    }
</style>
